module.exports = {
  site: {
    title: `Cobalt`,
    description: `Cobalt`, // Used in the meta description
    siteUrl: `https://www.cobalt.systems`, // No trailing slash
    // twitterHandle: `@batchnz`,
    image: `site-image.jpg`, // Relative to the folder `./static/`
  },
  manifest: {
    shortName: `Cobalt`, // Under 12 characters.
    bgColor: `#ff006a`,
    themeColor: `#ff006a`,
    icon: `icon.svg`, // Relative to the folder `./src/images/`
  },
  google: {
    analytics: {
      trackingId: `UA-162523381-1`,
    },
    tagManager: {
      id: `GTM-PFSSFNG`
    }
  },
  prismic: {
    repository: `cobalt001`,
  },
}
